<template>
    <section class="h-full w-full flex flex-col">
        
        <div :style="backgroundStyle" class="ht-auto sm:ht-300 md:ht-350 lg:ht-400 xl:ht-500 2xl:ht-600 w-full bg-cover bg-no-repeat bg-center relative bg-image">
        </div>
        <div class="w-full mt-8 px-8">
            <div class="container mx-auto">
                <bread-crumb :items="breadCrumbItems"></bread-crumb>
            </div>
        </div>
        <div class="px-8 my-8">
            <div class="container mx-auto">
                <div class="bg-1 text-white px-4 py-2 text-2xl font-bold flex items-center">
                    <icon-back @click.stop="$router.go(-1)" class="zoom-in"></icon-back>
                    <h1 class="ml-2">Photo Gallery</h1>
                </div>
                <div class="h-full flex justify-center items-center mt-8" v-if="$apollo.queries.photoGallery.loading && page == 1"><base-spinner></base-spinner></div>
                <div v-else-if="!$apollo.queries.photoGallery.loading && !hasItems" class="h-full flex justify-center items-center mt-8">
                    <h1 class="text-center text-xl font-medium">No Photo found!</h1>
                </div>
                <div v-else class="flex flex-col mt-8">
                    <div class="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-4 gap-8">
                        <div v-for="(item, index) in items" :key="index" class="flex">
                            <img @click.stop="openGalleryBox(index)" class="cursor-pointer h-48 md:h-64 xl:h-80 w-full object-contain border p-4" :src="getImage(item.thumbnail)" />
                        </div>
                    </div>

                    <div class="h-full flex justify-center items-center mt-8" v-if="$apollo.queries.photoGallery.loading && page > 1"><base-spinner></base-spinner></div>

                    <div v-if="showViewMoreButton" class="flex justify-center mt-8">
                        <div @click="loadMore" class="border border-primary text-white hover:text-primary view-all bg-primary hover:bg-white transition-all duration-200 px-4 py-2 cursor-pointer">View More</div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <gallery-box v-if="isOpenGalleryBox" :selected-slide="currentSlide" :items="items" @close="closeGalleryBox"></gallery-box>
                    </transition>

                </div>  
            </div>
        </div>
    </section>
</template>

<script>
import gql from 'graphql-tag';
import GalleryBox from  "../../components/shared/GalleryBox.vue";
import BreadCrumb from  "../../components/shared/BreadCrumb.vue";
import backgroundImage from '../../assets/images/news/img1.png';
import IconBack from "../../components/icons/IconBack.vue";
export default {
    name: "photo-gallery",
    components: {
        GalleryBox,
        BreadCrumb,
        IconBack,
    },
    data() {
      return {
        photoGallery: [],
        first: 12,
        page: 1,
        breadCrumbItems: [
            { label: 'Home', path: '/' },
            { label: 'Photo Gallery' },
        ],
        isOpenGalleryBox: false,
        activeImg: null,
        currentSlide: null,
      };
    },
    computed: {
        backgroundStyle () {
            return {
                'background-image': `url(${backgroundImage})`
            }
        },
        items() {
            return this.photoGallery.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.photoGallery.paginatorInfo;
        },
        showViewMoreButton() {
            return this.paginatorInfo.hasMorePages;
        },
    },
    apollo: {
        photoGallery () {
            return {
                query: gql`query GetPhotoGallery($first: Int!, $page: Int!) {
                    photoGallery(first: $first, page: $page) {
                        data {
                            thumbnail
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables () {
                    return {
                        first: this.first,
                        page: 1,
                    }
                },
            }
        },
    },
    methods: {
        getImage(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        loadMore() {
            this.page += 1;
            this.$apollo.queries.photoGallery.fetchMore({
            variables: {
                first: this.first,
                page: this.page,
            },

            updateQuery: (previousResult, { fetchMoreResult }) => {

                const newItems = fetchMoreResult.photoGallery.data;
                const newPaginatorInfo = fetchMoreResult.photoGallery.paginatorInfo;

                return {
                    photoGallery: {
                        __typename: previousResult.photoGallery.__typename,
                        data: [...previousResult.photoGallery.data, ...newItems],
                        paginatorInfo: newPaginatorInfo,
                    }
                }
                
            }
            })
        },
        openGalleryBox(currentSlide) {
            this.currentSlide = currentSlide;
            this.isOpenGalleryBox = true;
        },
        closeGalleryBox() {
            this.isOpenGalleryBox = false;
            this.activeImg = null;
        },
    },
}
</script>

<style lang="scss" scoped>
.bg-1 {
  background: linear-gradient(90deg, rgba(34,42,57,1) 0%, rgba(10,66,117,1) 100%);
}
@responsive {
    .ht-auto {
        height: auto;
    }
    .ht-600 {
        height: 600px;
    }
    .ht-500 {
        height: 500px;
    }
    .ht-400 {
        height: 400px;
    }
    .ht-350 {
        height: 350px;
    }
    .ht-300 {
        height: 300px;
    }
}
.bg-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>